/**
 * Run all sagas
 */

import { all } from 'typed-redux-saga';
import { catalogueRootSaga } from 'containers/catalogue/catalogue/saga';
import { instoreRootSaga } from 'containers/instore/saga';
import { instoreServiceRootSaga } from 'containers/instore/';
import { servicesListingRootSaga } from 'containers/categories-listing';
import { pageModelRootSaga } from './pageModel';

// [IMPORT NEW SLICESAGA ABOVE] < Needed for generating slices seamlessly

export function* rootSaga(): Generator<unknown> {
	yield all([
		pageModelRootSaga(),
		catalogueRootSaga(),
		instoreRootSaga(),
		instoreServiceRootSaga(),
		servicesListingRootSaga(),
		// [INSERT NEW SLICE SAGA ABOVE] < Needed for generating slices seamlessly
	]);
}
